import { createSelector } from 'reselect';
import { IDivorce, IDivorcesState } from 'types/divorces.types';
import { IDivorcesFormData } from 'views/public/DivorcesView/components/DivorcesForm/types';

const getItems = (state: { divorces: IDivorcesState }) => state.divorces.items;
const getSelectedItem = (state: { divorces: IDivorcesState }) => state.divorces.selectedItem;
const getIdCardTypes = (state: { divorces: IDivorcesState }) => state.divorces.idCardTypes;

export const divorcesSelector = createSelector([getItems], (divorces) =>
  divorces.map((divorce: IDivorce) => ({
    ...divorce,
    fullName: `${divorce.husband.lastName || ''} ${divorce.husband.firstName || ''} y ${
      divorce.wife.lastName || ''
    } ${divorce.wife.firstName || ''}`,
  })),
);

export const divorceFormSelector = createSelector(
  [getSelectedItem],
  (divorce): IDivorcesFormData => ({
    husband: {
      id: divorce?.husband?.id || 0,
      firstName: divorce?.husband?.firstName || '',
      lastName: divorce?.husband?.lastName || '',
      address: divorce?.husband?.address || '',
      apartment: divorce?.husband?.apartment || '',
      locality: divorce?.husband?.locality || '',
      areaCode: divorce?.husband?.areaCode || '',
      phone: divorce?.husband?.phone || '',
      idCardType: divorce?.husband?.idCardType,
      idCard: divorce?.husband?.idCard || '',
      email: divorce?.husband?.email || '',
    },
    wife: {
      id: divorce?.wife?.id || 0,
      firstName: divorce?.wife?.firstName || '',
      lastName: divorce?.wife?.lastName || '',
      address: divorce?.wife?.address || '',
      apartment: divorce?.wife?.apartment || '',
      locality: divorce?.wife?.locality || '',
      areaCode: divorce?.wife?.areaCode || '',
      phone: divorce?.wife?.phone || '',
      idCardType: divorce?.wife?.idCardType,
      idCard: divorce?.wife?.idCard || '',
      email: divorce?.wife?.email || '',
    },
    weddingTemple: divorce?.weddingTemple || '',
    weddingDate: divorce?.weddingDate || '',
    comments: divorce?.comments || '',
  }),
);

export const divorcesIdCardTypesSelector = createSelector([getIdCardTypes], (idCardTypes) =>
  Object.keys(idCardTypes).map((key) => ({
    label: idCardTypes[key],
    value: key,
  })),
);

export const divorcesFilesSelector = createSelector([getSelectedItem], (divorce) => ({
  ketubaFile: divorce?.ketubaFile || '',
  marriageCertificateFile: divorce?.marriageCertificateFile || '',
  divorceCertificateFile: divorce?.divorceCertificateFile || '',
  husbandIdCardFile: divorce?.husband?.idCardFile || '',
  husbandIdCardBackFile: divorce?.husband?.idCardBackFile || '',
  husbandKetubaFile: divorce?.husband?.ketubaFile || '',
  husbandMarriageCertificateFile: divorce?.husband?.marriageCertificateFile || '',
  wifeIdCardFile: divorce?.wife?.idCardFile || '',
  wifeKetubaFile: divorce?.wife?.ketubaFile || '',
  wifeMarriageCertificateFile: divorce?.wife?.marriageCertificateFile || '',
  wifeIdCardBackFile: divorce?.wife?.idCardBackFile || '',
}));
